
import React from 'react';

function PageNotFound() {
  return (
    <div className="container">
      <div className="row" style={{ display: 'flex', justifyContent: 'center' }}>
          <h1>Page Not Found</h1>         
      </div>      
    </div>
  );
}

export default PageNotFound;